import "./ScrollToTop.scss"

import React, { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import { Icon } from "@fider/components"
import IconChevronUp from "@fider/assets/images/chevron-up.svg"
import { i18n } from "@lingui/core"

// Tùy biến KHCN: nút cuộn lên đầu trang, hiện khi cuộn xuống, cuộn mượt khi bấm.
const SHOW_AFTER = 480

export const ScrollToTop = () => {
  const [visible, setVisible] = useState(false)
  // Chỉ dựng portal sau khi mount ở client: createPortal không chạy khi render phía server
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" })

  if (!mounted || typeof document === "undefined") {
    return null
  }

  return ReactDOM.createPortal(
    <button
      type="button"
      className={`c-scrolltop ${visible ? "c-scrolltop--visible" : ""}`}
      onClick={toTop}
      aria-label={i18n._({ id: "khcn.scrolltop", message: "Back to top" })}
      title={i18n._({ id: "khcn.scrolltop", message: "Back to top" })}
      tabIndex={visible ? 0 : -1}
    >
      <Icon sprite={IconChevronUp} />
    </button>,
    document.body
  )
}
